import * as React from 'react';
import { BulkEditModalLayout } from './BulkEditModalLayout';

interface UnsupportedModeViewProps {
  title: string;
  featureName: string;
  methodType?: string;
  onBack: () => void;
  onClose: () => void;
}

export const UnsupportedModeView = ({
  title,
  featureName,
  methodType = 'live rate',
  onBack,
  onClose,
}: UnsupportedModeViewProps) => {
  return (
    <BulkEditModalLayout title={title} onClose={onClose} onBack={onBack}>
      <div className="bulk-edit-modal__unsupported">
        <h3 className="bulk-edit-modal__unsupported-title">Not Available</h3>
        <p className="bulk-edit-modal__unsupported-description">
          Bulk editing {featureName} is not available for {methodType} methods. Please edit these methods individually.
        </p>
      </div>
    </BulkEditModalLayout>
  );
};
